// extracted by mini-css-extract-plugin
module.exports = {"root":"TableCheckbox_root__3a8Cc","checked":"TableCheckbox_checked__28f5n","partly":"TableCheckbox_partly__2I13H"};